type CurrencyType = 1 | 2;

const UNIDADES = [
    "",
    "UNO",
    "DOS",
    "TRES",
    "CUATRO",
    "CINCO",
    "SEIS",
    "SIETE",
    "OCHO",
    "NUEVE",
    "DIEZ",
    "ONCE",
    "DOCE",
    "TRECE",
    "CATORCE",
    "QUINCE",
    "DIECISÉIS",
    "DIECISIETE",
    "DIECIOCHO",
    "DIECINUEVE",
];

const DECENAS = [
    "",
    "DIEZ",
    "VEINTE",
    "TREINTA",
    "CUARENTA",
    "CINCUENTA",
    "SESENTA",
    "SETENTA",
    "OCHENTA",
    "NOVENTA",
];

const CENTENAS = [
    "",
    "CIENTO",
    "DOSCIENTOS",
    "TRESCIENTOS",
    "CUATROCIENTOS",
    "QUINIENTOS",
    "SEISCIENTOS",
    "SETECIENTOS",
    "OCHOCIENTOS",
    "NOVECIENTOS",
];

const CURRENCY_LABELS: Record<CurrencyType, string> = {
    1: "COLONES",
    2: "DÓLARES",
};

function convertGroup(n: number): string {
    if (n === 100) return "CIEN";

    let output = "";

    if (n > 99) {
        output += CENTENAS[Math.floor(n / 100)] + " ";
        n = n % 100;
    }

    if (n >= 20) {
        output += DECENAS[Math.floor(n / 10)];
        if (n % 10 !== 0) output += " Y " + UNIDADES[n % 10];
    } else if (n > 0) {
        output += UNIDADES[n];
    }

    return output.trim();
}

function convertNumber(num: number): string {
    if (num === 0) return "CERO";

    let result = "";
    const millones = Math.floor(num / 1_000_000);
    const miles = Math.floor((num % 1_000_000) / 1000);
    const cientos = num % 1000;

    if (millones > 0) {
        result += millones === 1
            ? "UN MILLÓN "
            : convertNumber(millones) + " MILLONES ";
    }

    if (miles > 0) {
        result += miles === 1 ? "MIL " : convertGroup(miles) + " MIL ";
    }

    if (cientos > 0) {
        result += convertGroup(cientos);
    }

    return result.trim();
}

export function numberToWords(value: number, currencyType: CurrencyType = 1): string {
    if (isNaN(value)) return "";

    const integerPart = Math.floor(value);
    const decimalPart = Math.round((value - integerPart) * 100);
    const currency = CURRENCY_LABELS[currencyType];

    const words = convertNumber(integerPart);
    const decimals = decimalPart.toString().padStart(2, "0");

    return `${words} ${currency} ${decimals}/100`;
}